<template>
  <template
    v-if="item.features.qualityCertifications.length > 0 || hasFeatures"
  >
    <SSection
      :desktop-full="true"
      :title="t('views.cottage.characteristics.title')"
    >
      <CottageSectionCharacteristicsCertifications
        :item="item"
      ></CottageSectionCharacteristicsCertifications>

      <div v-if="hasFeatures" class="grid grid-cols-2 lg:grid-cols-4 gap-x-6">
        <template v-if="fiveFeaturesGroups">
          <div>
            <CottageSectionCharacteristicsList
              :item="{
                title: t('views.cottage.characteristics.exteriors'),
                list: item.features.exteriors,
              }"
            ></CottageSectionCharacteristicsList>
            <CottageSectionCharacteristicsList
              :item="{
                title: t('views.cottage.characteristics.accessibilities'),
                list: item.features.accessibilities,
              }"
            ></CottageSectionCharacteristicsList>
          </div>
        </template>

        <template v-else>
          <div v-if="item.features.exteriors.length > 0">
            <CottageSectionCharacteristicsList
              :item="{
                title: t('views.cottage.characteristics.exteriors'),
                list: item.features.exteriors,
              }"
            ></CottageSectionCharacteristicsList>
          </div>
          <div v-if="item.features.accessibilities.length > 0">
            <CottageSectionCharacteristicsList
              :item="{
                title: t('views.cottage.characteristics.accessibilities'),
                list: item.features.accessibilities,
              }"
            ></CottageSectionCharacteristicsList>
          </div>
        </template>

        <div v-if="item.features.interiors.length > 0">
          <CottageSectionCharacteristicsList
            :item="{
              title: t('views.cottage.characteristics.interiors'),
              list: item.features.interiors,
            }"
          ></CottageSectionCharacteristicsList>
        </div>

        <div v-if="item.features.services.length > 0">
          <CottageSectionCharacteristicsList
            :item="{
              title: t('views.cottage.characteristics.services'),
              list: item.features.services,
            }"
          ></CottageSectionCharacteristicsList>
        </div>

        <div v-if="item.features.situations.length > 0">
          <CottageSectionCharacteristicsList
            :item="{
              title: t('views.cottage.characteristics.situations'),
              list: item.features.situations,
            }"
          ></CottageSectionCharacteristicsList>
        </div>
      </div>
    </SSection>
  </template>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = {
  features: Pick<
    CottagePage['features'],
    | 'exteriors'
    | 'interiors'
    | 'services'
    | 'accessibilities'
    | 'situations'
    | 'qualityCertifications'
  >
}

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const hasFeatures =
  props.item.features.exteriors.length > 0 ||
  props.item.features.interiors.length > 0 ||
  props.item.features.services.length > 0 ||
  props.item.features.accessibilities.length > 0 ||
  props.item.features.situations.length > 0

const fiveFeaturesGroups =
  props.item.features.exteriors.length > 0 &&
  props.item.features.interiors.length > 0 &&
  props.item.features.services.length > 0 &&
  props.item.features.accessibilities.length > 0 &&
  props.item.features.situations.length > 0
</script>
